(function(){
var body=document.getElementById('lrBody');if(!body)return;
  var search=document.getElementById('lrSearch'),catSel=document.getElementById('lrCat'),
      emptyEl=document.getElementById('lrEmpty'),brandWrap=document.getElementById('lrBrands');
  var rows=[].slice.call(body.querySelectorAll('.lr-row'));
  var brand='all';
  function apply(){
    var q=(search.value||'').toLowerCase().replace(/\s+/g,''),cat=catSel.value,shown=0;
    rows.forEach(function(row){
      var det=row.nextElementSibling;
      var b=row.getAttribute('data-batch').replace(/\s+/g,''),
          p=row.getAttribute('data-product'),br=row.getAttribute('data-brand'),c=row.getAttribute('data-cat');
      var ok=(!q||b.indexOf(q)>-1||p.replace(/\s+/g,'').indexOf(q)>-1)&&(brand==='all'||br===brand)&&(cat==='all'||c===cat);
      row.style.display=ok?'':'none';
      if(det&&det.classList.contains('lr-detail')){det.classList.remove('show');row.classList.remove('open');}
      if(ok)shown++;
    });
    emptyEl.style.display=shown?'none':'';
  }
  rows.forEach(function(row){
    row.addEventListener('click',function(){
      var det=row.nextElementSibling;if(!det||!det.classList.contains('lr-detail'))return;
      var open=det.classList.contains('show');
      det.classList.toggle('show',!open);row.classList.toggle('open',!open);
    });
  });
  search.addEventListener('input',apply);
  catSel.addEventListener('change',apply);
  brandWrap.addEventListener('click',function(e){
    var b=e.target.closest('.lr-pill');if(!b)return;
    brand=b.getAttribute('data-brand');
    brandWrap.querySelectorAll('.lr-pill').forEach(function(x){x.classList.toggle('on',x===b);});
    apply();
  });
  apply();
})();
